import SessionEventProto from "../session-event-proto"

export default class SessionEventDelta extends SessionEventProto {

    private header : {
        event       : any
        isBulkUpdate: boolean
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.method     = sessionEvent.method
        this.header     = {
            event       : sessionEvent.event,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (_.isEmpty(this.data)) return // no data in event then nothing should be done about it (noticed when deadline is set to same value)

        if (this.isDifferentCompany()) return false;
        if (!!gd.session.events) gd.session.events.applyDelta(this.header.event.id, this.data);

        // console.log("SessionEventDelta process", this);

        gd.modelBus.newUpdate('event', this.method, this.header.event.id, this.data, this.header);
    }
}